import React from 'react';

import { Heading3, Heading5, spacing } from '../../../../theme';
import { NameValuePair, PaymentSection } from '../models';
import PaymentItem from './payment-item';
import { Block, PaymentContainer, PaymentHeader } from './style';
import TotalItem from './total-item';
import { styled } from 'styled-components';
import PaymentSubtotal from './subtotal-item';

type PaymentSummaryProps = {
    sectionTitle: string,
    columnHeader1: string,
    columnHeader2: string,
    payment: PaymentSection;
    className?: string;
    isEng?: boolean;
};
const StyledHeading = styled(Heading3)`
    display: flex;
    align-items: center;
    gap: ${spacing.spacing2};
`;

const renderItemEntries = (items: NameValuePair[]) => {
    const html = [];
    let index = 0;
    items.forEach(({name, value}) => {
        html.push(
            <>
                <PaymentItem
                    key={index}
                    item={name}
                    amount={value}
                    last={items.length - 1 === index++}
                />
            </>);
    });
    return html;
};

const renderSubtotalEntries = (subtotals: NameValuePair[]) => {
    const html = [];
    let index = 0;
    subtotals.forEach(({name, value}) => {
        html.push(
            <>
                <PaymentSubtotal
                    key={index++}
                    item={name}
                    amount={value}
                />
            </>);
    });
    return html;
};

const renderTotalEntries = (totals: NameValuePair[]) => {
    const html = [];
    let index = 0;
    totals.forEach(({name, value}) => {
        html.push(
            <>
                <TotalItem
                    key={index++}
                    item={name}
                    amount={value}
                />
            </>);
    });
    return html;
};

export default function PaymentSummary({
    sectionTitle,
    columnHeader1,
    columnHeader2,
    payment: { itemEntriesEn, itemEntriesFr, subTotalEntriesEn, subTotalEntriesFr, totalEntriesEn, totalEntriesFr },
    className,
    isEng  // cannot have default value, null means French
}: PaymentSummaryProps) {
    let index = 0;
    return (
        <PaymentContainer className={className}>
            <StyledHeading styledAs="h3">{sectionTitle}</StyledHeading>
            <PaymentHeader>
                <Block>
                    <Heading5>{columnHeader1}</Heading5>
                </Block>
                <Block>
                    <Heading5>{columnHeader2}</Heading5>
                </Block>
            </PaymentHeader>
            <>
                {itemEntriesEn?.length && renderItemEntries(isEng ? itemEntriesEn : itemEntriesFr)}
            </>
            <>
                {subTotalEntriesEn?.length && renderSubtotalEntries(isEng ? subTotalEntriesEn : subTotalEntriesFr)}
            </>
            <>
                {totalEntriesEn ?.length && renderTotalEntries(isEng ? totalEntriesEn : totalEntriesFr)}
            </>
        </PaymentContainer>
    );
}
